<template lang="pug">
  #app
    site-header(v-if="!fullScreen && !isIframeMode")
    car-selector(v-if="!isCarSelected && false", @selectCar="onCarSelect" )
    car-configurator
    template(v-if="isCarSelected")
        info-section
        site-footer(v-if="!isIframeMode && !fullScreen")
</template>
<script>
import SiteHeader from "./components/SiteHeader";
import CarSelector from "./components/CarSelector";
import InfoSection from "./components/InfoSection";
import SiteFooter from "./components/SiteFooter";
import CarConfigurator from "./components/CarConfigurator";
import isMobileMixin from "./components/mixins/isMobileMixin";
import {mapActions, mapGetters} from "vuex";
import iframeMixin from "./components/mixins/iframeMixin";

export default {
  mixins: [isMobileMixin, iframeMixin],
  components: {CarConfigurator, SiteFooter, InfoSection, CarSelector, SiteHeader},
  data() {
    return {
      isCarSelected: true
    }
  },

  created() {
   {
      this.enableIframe()
    }

    this.setCarModel(this.$route.name === 'polo' ? 'polo' : 'jetta')
  },

  mounted() {
    setTimeout(() => {
      window.scroll(0,0)
    }, 1000)

    document.addEventListener('click', e => {
      if ((e.target instanceof HTMLButtonElement || e.target.classList.contains('button')) &&
        !e.target.classList.contains('toggle-sound') &&
        !e.target.classList.contains('interior') &&
          !e.target.classList.contains('wheels') &&
        !e.target.classList.contains('color')) {
        if (e.target.closest('.slider-wrapper') === null) {
          e.target.classList.add('light')
          setTimeout(() => {
            e.target.classList.remove('light')
          }, 400)
        }
      }


      const gaCategory = e.target.getAttribute('ga-category')

      if (gaCategory) {
        const gaLabel = e.target.getAttribute('ga-label')
        this.postIframeEvent(gaLabel)
        // fetch('/stat', {
        //   method: 'POST', // *GET, POST, PUT, DELETE, etc.
        //   mode: 'cors', // no-cors, *cors, same-origin
        //   cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        //   credentials: 'same-origin', // include, *same-origin, omit
        //   headers: {
        //     'Content-Type': 'application/json'
        //     // 'Content-Type': 'application/x-www-form-urlencoded',
        //   },
        //   redirect: 'follow', // manual, *follow, error
        //   referrerPolicy: 'no-referrer', // no-referrer, *client
        //   body: JSON.stringify({
        //     label: gaLabel
        //   }) // body data type must match "Content-Type" header
        // });
        // // window.gtag('event', 'click', {
        // //   'event_category': gaCategory,
        // //   'event_label': gaLabel,
        // // })
      }
    })
  },

  computed: {
    ...mapGetters(['isIframeMode', 'fullScreen', 'carModel'])
  },

  methods: {
    ...mapActions(['enableIframe', 'disableIframe', 'setCarModel']),
    onCarSelect() {
      this.isCarSelected = true
    }
  }
}
</script>